export const enterpriseDashboardData = {
  header: {
    budgetLabel: "713,400",
    forecastYear: "2026",
    beneficiaries: 2560,
    companyBadge: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    displayDate: "26 juin 2026",
    budgetHeader: "",
  },
  budget: {
    allocatedAmount: "$713,400",
    forecastLabel: "Prévision annuelle 2026",
    forecastPeriodLabel: "Du 01/01/2026 au 31/12/2026",
    allocationDetail: "",
    periodStart: "01/01/2026",
    periodEnd: "31/12/2026",
    cumulativeDate: "26/06/2026",
    cumulativePercent: "59.5 %",
    cumulativeAmount: "$424,594",
    outOfPackageDate: "26/06/2026",
    outOfPackagePercent: "12.2 %",
    outOfPackageAmount: "$86,724",
  },
  averageConsumption: {
    attendanceRate: "33 %",
    amountPerAdmission: "$286",
    amountPerAgent: "$614",
    admittedAgents: "228 / 691",
  },
  workforce: {
    total: "2560",
    agents: "691",
    spouses: "433",
    children: "1436",
  },
  attendance: {
    total: "569",
    agents: "228",
    spouses: "84",
    children: "257",
  },
  metrics: {
    admissions: { value: "6", footer: "Fréquentation du jour" },
    allInvoices: { value: "0", amount: "$0" },
    outOfPackageInvoices: { value: "8", amount: "$13,788,741" },
    inProgress: { value: "0", amount: "$0" },
    validated: { value: "0", amount: "$0" },
    savings: { value: "0 %", footer: "$0", requested: "$0", validated: "$0" },
  },
  quickAccess: [
    { id: "admissions", href: "/dashboard/admissions" },
    { id: "invoices", href: "/dashboard/invoices" },
    { id: "agents", href: "/dashboard/employees" },
    { id: "beneficiaries", href: "/dashboard/beneficiaries" },
  ],
  visitDistribution: {
    agents: [
      { name: "MPANZU MPANZU", count: 22 },
      { name: "MAKOKO KAMBOLO", count: 21 },
      { name: "KABONGO TSHILOMBO", count: 18 },
      { name: "ABEMBA ATEBA", count: 15 },
      { name: "MUKENDI MARIE", count: 12 },
    ],
    spouses: [
      { name: "DILUBENZI MAYINDU T...", count: 16 },
      { name: "IMANI TUMBA", count: 11 },
      { name: "BUKASA NGOLO", count: 9 },
      { name: "MWEMA MUNGU", count: 7 },
      { name: "LUSHIMBA NGOLO", count: 5 },
    ],
    children: [
      { name: "MATADI WAMBA KIMW...", count: 9 },
      { name: "KABONGO JUNIOR", count: 8 },
      { name: "MUKENDI SARA", count: 6 },
      { name: "ABEMBA GRACE", count: 5 },
      { name: "KALONJI PAUL", count: 4 },
    ],
  },
  frequentPathologies: {
    agents: [
      { name: "Non renseigné", count: 23 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
    ],
    spouses: [
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
    ],
    children: [
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
      { name: "-", count: 0 },
    ],
  },
  careTypes: [
    { type: "pharmacy", quantity: 0, price: "$0" },
    { type: "nursing", quantity: 0, price: "$0" },
    { type: "imagingLab", quantity: 0, price: "$0" },
    { type: "consultation", quantity: 0, price: "$0" },
    { type: "surgery", quantity: 0, price: "$0" },
    { type: "rehabilitation", quantity: 0, price: "$0" },
  ],
  agePyramid: [
    { label: "de 0 à 3", value: 5 },
    { label: "de 3 à 10", value: 25 },
    { label: "de 10 à 18", value: 32 },
    { label: "de 18 à 30", value: 24 },
    { label: "de 30 à 50", value: 10 },
    { label: "+50 ans", value: 4 },
  ],
} as const;
